import React from 'react';
import { Button } from '@shadcn/components/ui/button';

const RemoveNotification = ({ onClick, isDisabled }) => (
  <div className="d-flex justify-content-end my-3 mr-3">
    <Button variant="primary" onClick={onClick} disabled={isDisabled}>
      Remove
    </Button>
  </div>
);

export default RemoveNotification;
